export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";